export default __webpack_public_path__ + "static/media/grandlale2.f1cd312f.jpg";